import moment from 'moment/moment';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { icons } from '~/assets';
import Button from '~/components/button';
import Checkbox from '~/components/checkbox';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Grid from '~/components/grid';
import Input, { MaskTypes } from '~/components/input';
import Loading from '~/components/loading';
import Pagination from '~/components/pagination';
import PasswordModal from '~/components/passwordModal';
import RadioButton from '~/components/radioButton';
import Select from '~/components/select';
import useApi, { ApiMethod } from '~/hooks/useApi';
import CardBlockPayload from '~/services/card/block/payload';
import CardBlockResponse from '~/services/card/block/response';
import { CancelClientPayload } from '~/services/card/cancel/payload';
import CardClienteBackofficeResponse from '~/services/card/getCardBackoffice/response';
import CardGetTokenPayload from '~/services/card/getToken/payload';
import CardGetTokenResponse from '~/services/card/getToken/response';
import CardReasonsForBlocking from '~/services/card/reasonsForBlocking/response';
import AgreementUsabilityPayload, {
  AgreementBenefit,
} from '~/services/consult/user/agreementUsability/payload';
import { ConsultUserLimitHistory } from '~/services/consult/user/detail/response';
import { SearchReasonsBlockResponse } from '~/services/consult/user/reasonsBlock/response';
import Endpoints from '~/services/endpoints';
import Termos from '~/services/terms';
import THEMES from '~/themes/themes';
import { useUserRole } from '~/hooks/contexts/useUserRole';
import { FormField } from '~/utils/form';
import * as Masks from '~/utils/masks';
import { cpfMask, IDefaultReturn } from '~/utils/masks';
import { EXPIRATION_DAYS } from '~/views/Consult/User/Detail/constants';
import * as St from '~/views/Consult/User/Detail/styles';
import SharedServiceContext from '~/views/Sales/EventsCenter/Services/sharedServiceContext';

interface Form {
  numeroCartao?: FormField;
  status?: FormField;
  temaCartao?: FormField;
  categoriaCartao?: FormField;
  dataImpressao?: FormField;
  dataEmissao?: FormField;
  diasAtraso?: FormField;
  dataAtivacao?: FormField;
  dataCorte?: FormField;
  diaVencimento?: FormField;
  melhorDiaCompra?: FormField;
  saldo?: FormField;
  documentoEmpregadorConvenio?: FormField;
  limiteDisponivelSaque?: FormField;
  limiteDisponivelTotal?: FormField;
  limiteConcedidoCompra?: FormField;
  limiteConcedidoSaque?: FormField;
  limiteConcedidoTotal?: FormField;
  limiteParcelado12x?: FormField;
  limiteParcelado12xDisponivel?: FormField;
  limiteCestaDisponivel?: FormField;
  limiteCestaConcedido?: FormField;
  origemOptin?: FormField;
  tipoCanc?: string;
  optinTermoDeUso?: boolean;
  checkWhatsApp?: boolean;
}

interface HistoryInactiveItem {
  dataOcorrencia: string;
  nomeSolicitante: string;
  origem: string;
  statusAntigo: string;
  statusNovo: string;
  tipoBeneficio: string;
}

interface HistoryInactiveResponse {
  data: HistoryInactiveItem[];
  page: number;
  pageSize: number;
  totalPages: number;
  totalSize: number;
}

const ProductContainer = ({
  product,
  cards,
  callbackUpdateInvoiceExpiration,
  callbackClickDuplicateCard,
  callbackBlockCard,
}) => {
  const { state } = useLocation<{ id: string; cpf: string }>();
  const user = JSON.parse(localStorage.getItem('@NovaEra:user'));
  const history = useHistory();
  const [cpf] = useState<IDefaultReturn>(cpfMask(user?.cpf) as IDefaultReturn);
  const [produto, setProduto] = useState('');
  const [form, setForm] = useState<Form>({
    numeroCartao: { name: 'numeroCartao', value: '' },
    status: { name: 'status', value: '' },
    temaCartao: { name: 'temaCartao', value: '' },
    categoriaCartao: { name: 'categoriaCartao', value: '' },
    dataImpressao: { name: 'dataImpressao', value: '' },
    dataEmissao: { name: 'dataEmissao', value: '' },
    diasAtraso: { name: 'diasAtraso', value: '' },
    dataAtivacao: { name: 'dataAtivacao', value: '' },
    dataCorte: { name: 'dataCorte', value: '' },
    diaVencimento: { name: 'diaVencimento', value: '' },
    melhorDiaCompra: { name: 'melhorDiaCompra', value: '' },
    saldo: { name: 'saldo', value: 0 },
    documentoEmpregadorConvenio: {name: "documentoEmpregadorConvenio", value: ''},
    limiteDisponivelSaque: { name: 'limiteDisponivelSaque', value: '0' },
    limiteDisponivelTotal: { name: 'limiteDisponivelTotal', value: '0' },
    limiteConcedidoCompra: { name: 'limiteConcedidoCompra', value: '0' },
    limiteConcedidoSaque: { name: 'limiteConcedidoSaque', value: '0' },
    limiteConcedidoTotal: { name: 'limiteConcedidoTotal', value: '0' },
    limiteParcelado12x: { name: 'limiteParcelado12x', value: '0' },
    limiteParcelado12xDisponivel: {
      name: 'limiteParcelado12xDisponivel',
      value: '0',
    },
    limiteCestaDisponivel: { name: 'limiteCestaDisponivel', value: '0' },
    limiteCestaConcedido: { name: 'limiteCestaConcedido', value: '0' },
    origemOptin: { name: 'origemOptin', value: '' },
    tipoCanc: 'CANCELAMENTO_SOLICITACAO',
    optinTermoDeUso: false,
    checkWhatsApp: false,
  });

  const {
    cardNumberForInfoCard,
    setCpfForInfoCard,
    setCardNumberForInfoCard,
    cardInfos,
  } = useContext(SharedServiceContext);

  const [previousDiaVencimento, setPreviousDiaVencimento] = useState('');
  const [loadingCardInfos, setLoadingCardInfos] = useState(true);

  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [dialogText, setDialogText] = useState('');
  const [balanceError, setBalanceError] = useState('');
  const [dialogHistory, setDialogHistory] = useState(false);
  const [dialogPlasticHistory, setDialogPlasticHistory] = useState(false);
  const [dialogHistoryInactives, setDialogHistoryInactives] = useState(false);
  const [dialogLimitHistory, setDialogLimitHistory] = useState(false);
  const [dialogLimitHistoryWithdraw, setDialogLimitHistoryWithdraw] = useState(
    false,
  );
  const [dialogDuplicateCard, setDialogDuplicateCard] = useState(false);
  const [dialogAskBlockCardShow, setDialogAskBlockCardShow] = useState(false);
  const [dialogErrorCancelCard, setDialogErrorCancelCard] = useState(false);
  const [dialogCancelCardShow, setDialogCancelCardShow] = useState(false);
  const [dialogCancelCardIsOpen, setDialogCancelCardIsOpen] = useState(false);
  const [ActivateDialog, setActivateDialog] = useState(false);
  const [messageActivate, setMessageActivate] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [cashBackPopUp, setCashBackPopUp] = useState(false);
  const [dialogPositiveBalance, setDialogPositiveBalance] = useState(false);
  const [tax, setTax] = useState<boolean | null>(null);
  const [standard, setStandard] = useState(false);
  const [dialogUpdateLimit, setDialogUpdateLimit] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [popUpError, setPopUpError] = useState(false);
  const [automaticLimit, setAutomaticLimit] = useState(false);
  const [hasWithdrawal, setHasWithdrawal] = useState(false);

  const [card, setCard] = useState<any>({});
  const [popUpMessage, setPopUpMessage] = useState('');
  const [popUpErrorMessage, setPopUpErrorMessage] = useState('');
  const [senha, setSenha] = useState('');
  const [optionsForBlocking, setOptionsForBlocking] = useState([]);
  const [reasonForBlocking, setReasonForBlocking] = useState(null);
  const [errorReasonBlock, setErrorReasonBlock] = useState<string | null>();
  const [zeussBalance, setZeussBalance] = useState(0);
  const [zeussPhone, setZeussPhone] = useState('');
  const [limitHistoryData, setLimitHistoryData] = useState([]);
  const [totalPagesLimitHistory, setTotalPagesLimitHistory] = useState(0);
  const [cardDesign, setCardDesign] = useState('');
  const [errorTax, setErrorTax] = useState<string | null>();
  const [errorCardDesign, setErrorCardDesign] = useState('');
  const [selectedAgreementUsability, setSelectedAgreementUsability] = useState<
    Omit<
      AgreementUsabilityPayload,
      'cpf' | 'documentoSolicitante' | 'nomeSolicitante'
    > | null
  >(null);
  const [modalPasswordOpen, setModalPasswordOpen] = useState<{
    open: boolean;
    type: 'twoWayCard' | 'blockCard' | 'cancelClient' | 'limit' | '';
  }>({ open: false, type: '' });

  const putAutomaticLimit = useApi(
    Endpoints.update.updateAutomaticLimit,
    ApiMethod.PUT,
  );
  const apiGetCardClientBackoffice = useApi<CardClienteBackofficeResponse>(
    Endpoints.consult.getCardClientBackoffice.replace(
      'PARAM_NUMERO_CARTAO',
      card.numeroCartao,
    ),
    ApiMethod.GET,
  );

  const RequestHistoryInactive = useApi<HistoryInactiveResponse>(
    Endpoints.companies.getHistoryInactiveUsability,
    ApiMethod.GET,
    {},
    true,
  );
  const RequestUpdateAgreementUsability = useApi(
    Endpoints.companies.postUpdateAgreementUsability,
    ApiMethod.POST,
  );

  const usabilidadeAtivaModalidades =
    apiGetCardClientBackoffice.data?.usabilidadeAtivaModalidades;
  const convenioLimitButtonLabel =
    usabilidadeAtivaModalidades?.ADIANTAMENTO_SALARIAL === false
      ? 'Ativar'
      : 'Inativar';
  const cestaBeneficioButtonLabel =
    usabilidadeAtivaModalidades?.CESTA_BENEFICIO === false
      ? 'Ativar'
      : 'Inativar';
  const hasPositiveBalance =
    (apiGetCardClientBackoffice.data?.creditoAMais ?? 0) > 0;

  const apiBlockCardReasons = useApi<CardReasonsForBlocking>(
    Endpoints.card.listOfReasonsForBlocking.replace(
      'PARAM_ORIGEM',
      'BACKOFFICE',
    ),
    ApiMethod.GET,
  );
  const apiCardToken = useApi<CardGetTokenResponse>(
    Endpoints.card.getToken,
    ApiMethod.POST,
  );
  const apiCancelClient = useApi<any>(
    Endpoints.consult.cancelCard.replace('PARAM_TIPO', form.tipoCanc),
    ApiMethod.POST,
  );
  const apiBlockCard = useApi<CardBlockResponse>(
    Endpoints.card.block,
    ApiMethod.PUT,
  );
  const AuthValidatePassword = useApi<any>(
    Endpoints.account.validateUserPassword,
    ApiMethod.POST,
  );
  const RequestInvoiceExpiration = useApi(
    Endpoints.update.invoiceExpiration,
    ApiMethod.POST,
  );
  const RequestConsultZeussBalance = useApi<any>(
    Endpoints.consult.getConsultZeussBalance.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );
  const RequestConsultZeussPhone = useApi<any>(
    Endpoints.consult.getConsultZeussPhone.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );
  const RequestHistoricCard = useApi<SearchReasonsBlockResponse>(
    Endpoints.consult.getCardHistory
    .replace('PARAM_CPF', state?.cpf)
    .replace('PARAM_PRODUTO', product),
    ApiMethod.GET,
  );
  const RequestPlasticCardHistory = useApi<SearchReasonsBlockResponse[]>(
    Endpoints.consult.getCardHistoryByCpf.replace(
      'PARAM_CPF',
      state?.cpf ?? '',
    ),
    ApiMethod.GET,
  );

  const POSTDuplicateCard = useApi(
    `${Endpoints.register.duplicateCard}`,
    ApiMethod.POST,
  );
  const getWithDrawLimit = useApi(
    Endpoints.consult.getWithDrawLimit.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );
  const getWithDrawLimitHistory = useApi(
    Endpoints.consult.getWithDrawLimitHistory.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );
  const getTotalLimit = useApi(
    Endpoints.consult.getTotalLimit.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );
  const consultLimitHistory = useApi<ConsultUserLimitHistory>(
    Endpoints.consult.getUserLimitHistory.replace(
      'PARAM_NUMERO_CARTAO',
      card.numeroCartao,
    ),
    ApiMethod.POST,
  );
  const getCampaignLimitIncrease = useApi(
    Endpoints.consult.getCampaignLimitIncrease.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );

  const { hasAnyRole } = useUserRole();

  const disabledButtonSave = () => !hasAnyRole(['ADM', 'SUP', 'MDC']);

  const handleUpdateInvoiceExpiration = async () => {
    const response = await RequestInvoiceExpiration.callApi({
      dia: form.diaVencimento.value,
      numeroCartao: form.numeroCartao?.value,
      senha: '',
    });

    if (response.status === 201) {
      setDialogText('Data de vencimento atualizada com sucesso!');
      callbackUpdateInvoiceExpiration();
    } else {
      setDialogText(
        response.mensagem || 'Falha ao atualizar data de vencimento.',
      );
    }
    setDialogIsOpen(true);
  };

  const handleTermsConditions = async () => {
    const filePath = Termos.termosCondicoes;
    window.open(filePath);
  };

  const handleTermsPrivacy = async () => {
    const filePath = Termos.termosPrivacidade;
    window.open(filePath);
  };

  const handleChange = (name: string, value: string) => {
    setForm((prev) => ({ ...prev, [name]: { value } }));
  };

  const handleCustomerBase = useCallback(async () => {
    const response = await getCampaignLimitIncrease.callApi();

    const { data }: any = response;

    if (response.status === 200) {
      setAutomaticLimit(data?.ativo);
    }
  }, []);

  const getZeussBalance = async () => {
    try {
      const response = await RequestConsultZeussBalance.callApi();
      if (response.status >= 200 && response.status < 300) {
        setZeussBalance(response.data?.saldo);
        setCashBackPopUp(true);
      } else if (response.status === 404) {
        setBalanceError(response.mensagem);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getZeussPhone = async () => {
    try {
      const response = await RequestConsultZeussPhone.callApi();
      if (response.status >= 200) {
        setZeussPhone(response.data?.celularZeuss);
        setCashBackPopUp(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getLimitHistory = async (page = 1, limit = 10) => {
    const payload = {
      periodoInicial: '2021-01-01',
      periodoFinal: moment(new Date()).format('YYYY-MM-DD'),
      tipoAumento: 'TODOS',
      limitePorPagina: limit,
      pagina: page,
    };

    const response = await consultLimitHistory.callApi(payload);

    const { data } = response;

    if (response.status === 200) {
      setLimitHistoryData(data?.pagina);
      setTotalPagesLimitHistory(data?.totalDePaginas);
    }
  };

  useEffect(() => {
    if (cardInfos) {
      setLoadingCardInfos(false);
    }
    if (form?.categoriaCartao) {
      if (form?.categoriaCartao?.value == 'Convênio') {
        setProduto('CONVENIO')
      } else {
        setProduto('TEUCARD')
      }
    }
  }, [cardInfos, form]);

  const askOtherCard = () => {
    if (cardDesign === 'PLATINUM') {
      setCardDesign(form.temaCartao.value?.toString());
    }

    const currentCardNumber = card?.numeroCartao;
    const needSearch =
      !cardInfos || cardNumberForInfoCard !== currentCardNumber;

    if (needSearch) {
      setCpfForInfoCard(state?.cpf); // dispara busca
      setCardNumberForInfoCard(currentCardNumber);
      setLoadingCardInfos(true);
    }

    setErrorTax('');
    setErrorCardDesign('');
    setDialogDuplicateCard(true);
  };

  const cancel = () => {
    const payloadCancel: CancelClientPayload = {
      cpf: state?.cpf,
    };

    apiCancelClient.callApi(payloadCancel);
  };

  const block = () => {
    if (!reasonForBlocking) {
      setErrorReasonBlock(
        'Erro ao bloquear cartão, escolha o motivo do bloqueio',
      );
      return;
    }
    setErrorReasonBlock(null);

    const res = apiCardToken.data as CardGetTokenResponse;

    const payloadBlock: CardBlockPayload = {
      idMotivo: reasonForBlocking,
      tokenCartao: res.tokenCartao,
    };

    apiBlockCard.callApi(payloadBlock);
  };

  async function handleClickDuplicateCard() {
    if (tax === null) return setErrorTax('Selecione uma opção');

    const response = await POSTDuplicateCard.callApi({
      numeroCartao: Masks.creditCardMask(form.numeroCartao?.value).unmasked,
      taxa: tax,
      cpfOperador: user.cpf,
      temaDoCartao: cardDesign,
    });

    if (response.status === 200 || response.status === 204) {
      callbackClickDuplicateCard();

      setDialogText('Segunda via do cartão solicitada com sucesso!');
      setDialogDuplicateCard(false);
    } else {
      setDialogText(
        response.mensagem
          ? response.mensagem
          : 'Falha ao solicitar segunda via do cartão!',
      );
      setDialogDuplicateCard(false);
    }
    setDialogIsOpen(true);
  }

  const getCardToken = async (cardNumber?: string) => {
    const payloadGetToken: CardGetTokenPayload = {
      numeroCartao: cardNumber,
    };

    const response = await apiCardToken.callApi(payloadGetToken);

    if (response.status > 300) {
      setDialogAskBlockCardShow(false);
      setDialogText(response.mensagem);
      setDialogErrorCancelCard(true);
    }
  };

  function getLastCardByProduct(product: string) {
    const filteredCards =
      cards?.filter((card) => card.tipoCartao === product) || [];
    return filteredCards.length > 0
      ? filteredCards[filteredCards.length - 1]
      : null;
  }

  const handleBlockCard = async () => {
    const card = getLastCardByProduct(product);
    const lastCard = card ? card.numeroCartao : null;

    await apiBlockCardReasons.callApi();
    getCardToken(lastCard);
    setDialogAskBlockCardShow(true);
  };

  const loadDataForBlockReasons = () => {
    const { data } = apiBlockCardReasons;

    const reasons = [];

    data.data?.map((e) =>
      reasons.push({
        id: e.idMotivo,
        value: e.descricao,
      }),
    );
    // id 11 é o motivo Cancel. Bloq. Backoffice
    const reasonsWithoutCancelBlockBackoffice = reasons.filter(
      (e) => e.id !== 11,
    );

    setOptionsForBlocking(reasonsWithoutCancelBlockBackoffice);
  };

  const handleUpdateAutomaticLimit = useCallback(async () => {
    setDialogUpdateLimit(false);
    try {
      const { status, mensagem } = await AuthValidatePassword.callApi({
        cpf: cpf?.unmasked,
        senha,
      });
      setSenha('');

      if (status >= 200 && status <= 300) {
        await putAutomaticLimit.callApi({
          ativo: !automaticLimit,
          cpf: state?.cpf,
        });
        setPopUpMessage(
          `Limite automático para o cliente ${
            automaticLimit ? 'DESATIVADO' : 'ATIVADO'
          } com sucesso.`,
        );
        setOpenDialog(true);
      } else {
        setPopUpErrorMessage(mensagem);
        setPopUpError(true);
      }
    } catch (err) {
      setPopUpErrorMessage(err.mensagem);
      setPopUpError(true);
    }
  }, [senha, automaticLimit]);

  const goBack = () => history.goBack();

  function formatDateTime(date) {
    if (!date) {
      return '';
    }
    return moment(date).format('DD/MM/YYYY HH:mm');
  }

  function formatDate(date) {
    if (!date) {
      return '';
    }
    return moment(date).format('DD/MM/YYYY');
  }

  const handleLimitHistory = async () => {
    await getLimitHistory();
    setDialogLimitHistory(true);
  };

  const handleLimitReactivate = (
    beneficio: AgreementBenefit,
    benefitLabel: string,
    buttonLabel: string,
    benefitNoun: string,
  ) => {
    const usabilidadeAtiva = buttonLabel === 'Ativar';

    setSelectedAgreementUsability({ beneficio, usabilidadeAtiva });
    setMessageActivate(
      `Deseja ${
        usabilidadeAtiva ? 'ativar' : 'inativar'
      } o ${benefitNoun} ${benefitLabel}?`,
    );
    setActivateDialog(true);
  };

  const handleLimitReactivatePurchase = () => {
    handleLimitReactivate(
      'CESTA_BENEFICIO',
      'Vale-compras',
      cestaBeneficioButtonLabel,
      'saldo',
    );
  };

  const handleLimitReactivateAgreement = () => {
    handleLimitReactivate(
      'ADIANTAMENTO_SALARIAL',
      'Convênio Multi',
      convenioLimitButtonLabel,
      'limite',
    );
  };

  const updateAgreementUsability = async () => {
    const fallbackMessage =
      'Não foi possível alterar o limite. Tente novamente.';

    setModalPasswordOpen({ open: false, type: '' });

    if (!selectedAgreementUsability || !state?.cpf) {
      setDialogText(fallbackMessage);
      setDialogIsOpen(true);
      setSelectedAgreementUsability(null);
      return;
    }

    try {
      const payload: AgreementUsabilityPayload = {
        cpf: state.cpf,
        ...selectedAgreementUsability,
        documentoSolicitante: user?.cpf,
        nomeSolicitante: user?.nomeTitular,
      };
      const response = await RequestUpdateAgreementUsability.callApi(payload);

      if (response.status >= 200 && response.status < 300) {
        await initializeFormCard();
        setDialogText(
          `${
            selectedAgreementUsability.usabilidadeAtiva
              ? 'Ativação'
              : 'Inativação'
          } de limite concluída com sucesso.`,
        );
      } else {
        setDialogText(response.mensagem || fallbackMessage);
      }
    } catch (error) {
      setDialogText(error?.mensagem || fallbackMessage);
    } finally {
      setSelectedAgreementUsability(null);
      setDialogIsOpen(true);
    }
  };

  const handleWithdrawalLimitHistory = async () => {
    await getWithDrawLimitHistory.callApi();
    setDialogLimitHistoryWithdraw(true);
  };

  const handlePlasticHistory = async () => {
    await RequestPlasticCardHistory.callApi();
    setDialogPlasticHistory(true);
  };

  async function fetchHistoryInactive(page = 1) {
    const documentoEmpregador = form.documentoEmpregadorConvenio?.value;

    if (!documentoEmpregador) return;

    await RequestHistoryInactive.callApi({
      cpf: state?.cpf,
      documentoEmpregador,
      page,
      limit: 10,
    });
  }

  async function initializeFormCard() {
    const cardClientResponse = await apiGetCardClientBackoffice.callApi();

    let diaVencimento =
      cardClientResponse.data?.diaVencimento || card.diaVencimento;
    let diaVencimentoFatura = (diaVencimento + '').padStart(2, '0');

    setHasWithdrawal(cardClientResponse.data?.temAlteracaoLimiteSaque);
    setForm((prevForm) => ({
      numeroCartao: {
        ...prevForm.numeroCartao,
        value: card.numeroCartao,
      },
      status: {
        ...prevForm.status,
        value: card.status,
      },
      origemOptin: {
        ...prevForm.origemOptin,
        value: card.origemOptin,
      },
      optinTermoDeUso: card.optinTermoDeUso,
      checkWhatsApp: card.checkWhatsApp,
      temaCartao: {
        ...prevForm.temaCartao,
        value:
          product == 'TEUCARD'
            ? cardClientResponse.data?.temaCartao
            : 'Convênio',
      },
      categoriaCartao: {
        ...prevForm.categoriaCartao,
        value:
          product == 'TEUCARD'
            ? cardClientResponse.data?.categoriaCartao
            : 'Convênio',
      },
      dataImpressao: {
        ...prevForm.dataImpressao,
        value: formatDate(cardClientResponse.data?.dataImpressao),
      },
      dataEmissao: {
        ...prevForm.dataEmissao,
        value: formatDate(cardClientResponse.data.dataEmissao),
      },
      diasAtraso: {
        ...prevForm.diasAtraso,
        value: (cardClientResponse.data?.dias_em_atraso || '0') + '',
      },
      dataAtivacao: {
        ...prevForm.dataAtivacao,
        value: formatDateTime(cardClientResponse.data?.dataAtivacao),
      },
      dataCorte: {
        ...prevForm.dataCorte,
        value: formatDate(cardClientResponse.data?.dataFechamento),
      },
      diaVencimento: {
        ...prevForm.diaVencimento,
        value: diaVencimentoFatura,
      },
      melhorDiaCompra: {
        ...prevForm.melhorDiaCompra,
        value: (cardClientResponse.data?.melhorDia || '') + '',
      },
      saldo: {
        ...prevForm.saldo,
        value: (cardClientResponse.data?.limiteCompraDisponivel || 0) + '',
      },
      documentoEmpregadorConvenio: {
        ...prevForm.documentoEmpregadorConvenio,
        value: (cardClientResponse.data.documentoEmpregadorConvenio || '') + ''
      },
      limiteDisponivelSaque: {
        ...prevForm.limiteDisponivelSaque,
        value: (cardClientResponse.data?.limiteSaqueDisponivel || '0') + '',
      },
      limiteDisponivelTotal: {
        ...prevForm.limiteDisponivelTotal,
        value: (cardClientResponse.data?.limiteDisponivelTotal || '0') + '',
      },
      limiteConcedidoCompra: {
        ...prevForm.limiteConcedidoCompra,
        value: (cardClientResponse.data?.limiteCompraConcedido || '0') + '',
      },
      limiteConcedidoSaque: {
        ...prevForm.limiteConcedidoSaque,
        value: (cardClientResponse.data?.limiteSaqueConcedido || '0') + '',
      },
      limiteConcedidoTotal: {
        ...prevForm.limiteConcedidoTotal,
        value: (cardClientResponse.data?.limiteConcedidoTotal || '0') + '',
      },
      limiteParcelado12x: {
        ...prevForm.limiteParcelado12x,
        value: (cardClientResponse.data?.limiteParcelado12x || '0') + '',
      },
      limiteParcelado12xDisponivel: {
        ...prevForm.limiteParcelado12xDisponivel,
        value:
          (cardClientResponse.data?.limiteParcelado12xDisponivel || '0') + '',
      },
      limiteCestaDisponivel: {
        ...prevForm.limiteCestaDisponivel,
        value: (cardClientResponse.data?.limiteCestaDisponivel || '0') + '',
      },
      limiteCestaConcedido: {
        ...prevForm.limiteCestaConcedido,
        value: (cardClientResponse.data?.limiteCesta || '0') + '',
      },
    }));
  }

  useEffect(() => {
    console.log('Lista de cartões', cards);
    if (product && cards) {
      console.log('mudança -> Lista de cartões', cards);
      const lastCard = getLastCardByProduct(product);
      setCard(lastCard);
    }
  }, [product, cards]);

  useEffect(() => {
    (async () => {
      console.log('Cartão', cards);
      if (card?.numeroCartao) {
        console.log('mudança -> Cartão', card);
        await initializeFormCard();
      }
    })();
  }, [card]);

  useEffect(() => {
    if (!dialogDuplicateCard) {
      setCardDesign('');
      setTax(null);
    } else if (
      form.temaCartao.value?.toString() === 'PLATINUM' &&
      dialogDuplicateCard
    ) {
      setCardDesign(form.temaCartao.value?.toString());
    }
  }, [dialogDuplicateCard]);

  useEffect(() => {
    if (form?.categoriaCartao.value) {
      if (form?.categoriaCartao.value !== 'PLATINUM') {
        setStandard(true);
      }
    }
  }, [form?.categoriaCartao.value]);

  useEffect(() => {
    if (apiBlockCardReasons.data) {
      loadDataForBlockReasons();
    }
  }, [apiBlockCardReasons.loading]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      if (apiBlockCard.status === 204) {
        setDialogAskBlockCardShow(false);
        callbackBlockCard();
        await initializeFormCard();
        setDialogText('Cartão bloqueado com sucesso');
        setDialogIsOpen(true);
        RequestHistoricCard.callApi();
      } else if (apiBlockCard.status === 404 || apiBlockCard.status === 406) {
        const res = apiBlockCard.data as CardBlockResponse;
        setDialogAskBlockCardShow(false);
        setDialogText(res.mensagem);
        setDialogIsOpen(true);
      } else if (apiBlockCard.status >= 500) {
        setDialogAskBlockCardShow(false);
        setDialogText(apiBlockCard.mensagem);
        setDialogIsOpen(true);
      }
      setLoading(false);
      if (apiCancelClient.status === 200) {
        setDialogCancelCardShow(false);
        setDialogText('Cliente cancelado com sucesso');
        setDialogCancelCardIsOpen(true);
      } else if (
        apiCancelClient.status === 404 ||
        apiCancelClient.status === 406 ||
        apiCancelClient.status >= 500
      ) {
        const res = apiCancelClient.data;
        setDialogCancelCardShow(false);
        setDialogText(res.mensagem);
        setDialogErrorCancelCard(true);
      }
    })();
  }, [apiBlockCard.loading || apiCancelClient.loading]);

  return (
    <ContainerFlex>
      <Loading
        status={
          apiBlockCardReasons.loading ||
          apiBlockCard.loading ||
          RequestInvoiceExpiration.loading ||
          POSTDuplicateCard.loading ||
          consultLimitHistory.loading ||
          apiCancelClient.loading ||
          AuthValidatePassword.loading ||
          putAutomaticLimit.loading ||
          apiGetCardClientBackoffice.loading ||
          getWithDrawLimitHistory.loading ||
          RequestHistoryInactive.loading ||
          RequestUpdateAgreementUsability.loading
        }
      />
      <Grid xs={1} lg={2} gap={30} alignItems={'flex-start'}>
        <ContainerFlex marginBottom={10}>
          <Input
            label="Número do cartão"
            value={Masks.creditCardMask(form.numeroCartao.value).masked}
            placeholder="0000.0000.0000.0000"
            maxLength={19}
            mask={MaskTypes.CREDIT_CARD}
            readOnly
          />

          <Input label="Status do cartão" value={form.status.value} readOnly />

          <Input
            label="Data de Impressão"
            value={form.dataImpressao.value}
            placeholder="DD/MM/YYYY"
            maxLength={10}
            mask={MaskTypes.DATE}
            readOnly
          />

          <Input
            label="Data de Emissão"
            value={form.dataEmissao.value}
            placeholder="DD/MM/YYYY"
            maxLength={10}
            mask={MaskTypes.DATE}
            readOnly
          />

          <Input
            label="Dias em atraso"
            value={form.diasAtraso?.value.toString() || '0'}
            readOnly
          />
        </ContainerFlex>

        <ContainerFlex>
          {(!product || product == 'TEUCARD') && (
            <ContainerFlex style={{ maxHeight: '52px' }} row align="center">
              <ContainerFlex style={{ padding: '5px, 5px' }}>
                <Select
                  label="Dia vencimento da fatura"
                  name={form.diaVencimento.name}
                  value={form.diaVencimento.value}
                  options={EXPIRATION_DAYS}
                  onChange={(val) => {
                    handleChange('diaVencimento', val);
                  }}
                  style={{ flex: 1 }}
                />
              </ContainerFlex>
              <Button
                style={{ width: 25, height: 37, marginLeft: 10 }}
                disabled={
                  form.diaVencimento.value === previousDiaVencimento ||
                  disabledButtonSave()
                }
                onClick={handleUpdateInvoiceExpiration}
              >
                Salvar
              </Button>
            </ContainerFlex>
          )}
          <ContainerFlex>
            <Input
              label="Melhor dia de compra"
              value={form.melhorDiaCompra.value?.substring(0, 2)}
              readOnly
            />
            <Input
              label="Data de corte da fatura"
              value={form.dataCorte.value}
              placeholder="DD/MM/YYYY"
              maxLength={10}
              mask={MaskTypes.DATE}
              readOnly
            />
          </ContainerFlex>
          <ContainerFlex
            row
            align="center"
            style={{ maxHeight: '52px', gap: 40 }}
          >
            <Input
              label="Categoria"
              value={form?.categoriaCartao.value?.toString() || '-'}
              readOnly
            />
            <Input
              label="Tema do cartão"
              value={form.temaCartao.value?.toString() || '-'}
              readOnly
            />
            {!standard && (
              <Button
                style={{ width: 25, height: 37, marginLeft: 10 }}
                onClick={() => {
                  getZeussBalance();
                  getZeussPhone();
                }}
                loading={
                  RequestConsultZeussBalance.loading &&
                  RequestConsultZeussPhone.loading
                }
              >
                Zeuss
              </Button>
            )}
          </ContainerFlex>

          <Grid xs={1} sm={2} lg={2} gap={20}>
            <ContainerFlex>
              <Input
                label="Origem"
                name={form.origemOptin.name}
                value={form.origemOptin.value ? form.origemOptin.value : '-'}
                readOnly
              />
            </ContainerFlex>
            <ContainerFlex>
              <Input
                label="Data e Hora"
                name={form.dataAtivacao.name}
                value={form.dataAtivacao?.value || '-'}
                readOnly
              />
            </ContainerFlex>
          </Grid>
        </ContainerFlex>

        <ContainerFlex marginBottom={30}>
          <Grid xs={1} sm={2} lg={2} gap={20}>
            <Input
              label={
                product === 'CONVENIO'
                  ? 'Limite disponível Convênio Multi'
                  : 'Limite disponível de compras'
              }
              name={form.saldo.name}
              value={Masks.currencyMask(
                apiGetCardClientBackoffice.data?.limiteCompraDisponivel || 0,
              )}
              readOnly
            />
            <ContainerFlex style={{ maxHeight: '52px' }} row align="center">
              <Input
                label={
                  product === 'CONVENIO'
                    ? 'Limite concedido Convênio Multi'
                    : 'Limite concedido de compras'
                }
                name={form.limiteConcedidoCompra.name}
                value={Masks.currencyMask(form.limiteConcedidoCompra.value)}
                readOnly
              />
              {(!product || product == 'TEUCARD') && (
                <Button
                  style={{ width: 25, height: 37, marginLeft: 10 }}
                  onClick={handleLimitHistory}
                >
                  Histórico
                </Button>
              )}
              {(!product || product == 'CONVENIO') && (
                <Button
                  style={{ width: 25, height: 37, marginLeft: 10 }}
                  onClick={handleLimitReactivateAgreement}
                >
                  {convenioLimitButtonLabel}
                </Button>
              )}
            </ContainerFlex>
            {product === 'CONVENIO' && (
              <Input
                label="Saldo disponível Vale-compras"
                name={form.limiteCestaDisponivel.name}
                value={Masks.currencyMask(
                  apiGetCardClientBackoffice.data?.limiteCestaDisponivel || 0,
                )}
                readOnly
              />
            )}
            {product === 'CONVENIO' && (
              <ContainerFlex style={{ maxHeight: '52px' }} row align="center">
              <Input
                label="Saldo concedido Vale-compras"
                name={form.limiteCestaConcedido.name}
                value={Masks.currencyMask(form.limiteCestaConcedido.value)}
                readOnly
              />
              
                <Button
                  style={{ width: 25, height: 37, marginLeft: 10 }}
                  onClick={handleLimitReactivatePurchase}
                >
                  {cestaBeneficioButtonLabel}
                </Button>
             
              </ContainerFlex>
            )}
           
            {(!product || product === 'TEUCARD') && (
              <Input
                label="Limite disponível de empréstimo"
                name={form.limiteDisponivelSaque.name}
                value={Masks.currencyMask(
                  apiGetCardClientBackoffice.data?.limiteSaqueDisponivel || 0,
                )}
                readOnly
              />
            )}
            {(!product || product == 'TEUCARD') && (
              <ContainerFlex style={{ maxHeight: '52px' }} row align="center">
                <Input
                  label="Limite concedido de empréstimo"
                  name={form.limiteConcedidoSaque.name}
                  value={Masks.currencyMask(form.limiteConcedidoSaque.value)}
                  readOnly
                />
                <Button
                  style={{ width: 25, height: 37, marginLeft: 10 }}
                  onClick={handleWithdrawalLimitHistory}
                  disabled={!hasWithdrawal}
                >
                  Histórico
                </Button>
              </ContainerFlex>
            )}

            {(!product || product === 'TEUCARD') && (
              <Input
                label="Limite disponível 12x"
                name={form.limiteParcelado12xDisponivel.name}
                value={Masks.currencyMask(
                  apiGetCardClientBackoffice.data
                    ?.limiteParcelado12xDisponivel || 0,
                )}
                readOnly
              />
            )}
            {(!product || product == 'TEUCARD') && (
              <Input
                label="Limite concedido 12x"
                name={form.limiteParcelado12x.name}
                value={Masks.currencyMask(form.limiteParcelado12x.value)}
                readOnly
              />
            )}
            {(!product || product === 'TEUCARD' || product === 'CONVENIO') && (
              <Input
                label="Limite disponível total"
                name={form.limiteDisponivelTotal.name}
                value={Masks.currencyMask(
                  apiGetCardClientBackoffice.data?.limiteDisponivelTotal || 0,
                )}
                readOnly
              />
            )}
            {(!product || product == 'TEUCARD' || product === 'CONVENIO') && (
              <Input
                label="Limite concedido total"
                name={form.limiteConcedidoTotal.name}
                value={Masks.currencyMask(form.limiteConcedidoTotal.value)}
                readOnly
              />
            )}
          </Grid>
          <Button
            style={{ marginTop: 15, width: 'fit-content' }}
            onClick={() => setDialogPositiveBalance(true)}
            disabled={!hasPositiveBalance}
          >
            Saldo positivo
          </Button>
        </ContainerFlex>
      </Grid>
      <ContainerFlex marginTop={10}>
        <span style={{ fontSize: '12px', color: '#757575' }}>Optin</span>
        <ContainerFlex>
          <Checkbox
            value={form.optinTermoDeUso}
            readonly
            terms={
              <>
                Li e concordo com os
                <St.ViewTerms onClick={() => handleTermsConditions()}>
                  Termos e condições de uso
                </St.ViewTerms>
                e a
                <St.ViewTerms onClick={() => handleTermsPrivacy()}>
                  Política de privacidade
                </St.ViewTerms>
              </>
            }
          />
        </ContainerFlex>
        <ContainerFlex>
          <Checkbox
            value={form.checkWhatsApp}
            readonly
            terms="Desejo receber comunicação do meu interesse por WhatsApp."
          />
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex align="center" marginTop={30}>
        <Grid
          xs={2}
          sm={product == 'TEUCARD' ? 5 : 3}
          lg={product == 'TEUCARD' ? 5 : 3}
          gap={15}
        >
        {product == 'CONVENIO' && (
          <Button
            onClick={() => {
              fetchHistoryInactive();
              setDialogHistoryInactives(true);
            }}
          >
            Histórico de Inativações
          </Button>
        )}
          <Button
            onClick={() => {
              RequestHistoricCard.callApi();
              setDialogHistory(true);
            }}
          >
            Histórico de Status do Cartão
          </Button>
          <Button
            onClick={handleBlockCard}
            disabled={
              form.status.value === 'CANCELAMENTO_EXPERIENCIA' ||
              form.status.value === 'CANCELAMENTO_SOLICITACAO' ||
              form.status.value === 'CANCELAMENTO_INATIVIDADE' ||
              form.status.value === 'CANCELAMENTO_PROPOSTA' ||
              form.status.value === 'INADIMPLENTE' ||
              form.status.value === 'CANCELADO' ||
              form.status.value === 'COBRANCA'
            }
            loading={isLoading}
          >
            Bloquear
          </Button>
          {(!product || product == 'TEUCARD') && (
            <Button
              onClick={() => setDialogCancelCardShow(true)}
              disabled={
                form.status.value === 'CANCELAMENTO_EXPERIENCIA' ||
                form.status.value === 'CANCELAMENTO_SOLICITACAO' ||
                form.status.value === 'CANCELAMENTO_INATIVIDADE' ||
                form.status.value === 'CANCELAMENTO_PROPOSTA' ||
                form.status.value === 'INADIMPLENTE' ||
                form.status.value === 'COBRANCA'
              }
            >
              Cancelar
            </Button>
          )}
          <Button
            onClick={askOtherCard}
            disabled={
              form.status.value === 'CANCELAMENTO_EXPERIENCIA' ||
              form.status.value === 'CANCELAMENTO_SOLICITACAO' ||
              form.status.value === 'CANCELAMENTO_INATIVIDADE' ||
              form.status.value === 'CANCELAMENTO_PROPOSTA' ||
              form.status.value !== 'CANCELADO'
            }
          >
            Solicitar 2ª via
          </Button>
          {(!product || product == 'TEUCARD') && (
            <Button onClick={() => setDialogUpdateLimit(true)}>
              Limite Automático
            </Button>
          )}
          <Button
            onClick={handlePlasticHistory}
            loading={RequestPlasticCardHistory.loading}
          >
            Histórico do Plástico
          </Button>
        </Grid>
      </ContainerFlex>

      <Dialog
        icon={icons.confirmation}
        open={dialogIsOpen}
        positiveLabel="Entendi"
        positiveAction={() => setDialogIsOpen(false)}
        message={dialogText}
      />

      <Dialog
        icon={icons.warning}
        open={cashBackPopUp}
        positiveLabel="Entendi"
        positiveAction={() => {
          setCashBackPopUp(false);
        }}
      >
        <div style={{ width: 400, height: 150 }}>
          <St.TableHistory>
            <thead>
              <tr>
                <th>Celular vinculado</th>
                <th>Saldo cashback</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{Masks.phoneMask(Masks.phoneUnmask(zeussPhone)).masked}</td>
                <td>{`R$ ${Masks.currencyMask(zeussBalance)}`}</td>
              </tr>
            </tbody>
          </St.TableHistory>
        </div>
        <span
          style={{ color: THEMES.colors.error, marginTop: 30, marginLeft: 60 }}
        >
          {balanceError}
        </span>
      </Dialog>

      <Dialog
        icon={icons.warning}
        open={dialogPositiveBalance}
        title={<span style={{ color: 'red' }}>Saldo positivo</span>}
        positiveLabel="Entendi"
        positiveAction={() => setDialogPositiveBalance(false)}
      >
        <div style={{ width: 400, minHeight: 120 }}>
          <St.TableHistory>
            <thead>
              <tr>
                <th>Saldo</th>
                <th>Referente a fatura</th>
              </tr>
            </thead>
            <tbody>
              {hasPositiveBalance && (
                <tr>
                  <td>
                    {`R$ ${Masks.currencyMask(
                      apiGetCardClientBackoffice.data?.creditoAMais ?? 0,
                    )}`}
                  </td>
                  <td>
                    {apiGetCardClientBackoffice.data
                      ?.dataVencimentoGerouCredito || '-'}
                  </td>
                </tr>
              )}
            </tbody>
          </St.TableHistory>
        </div>
        <span
          style={{
            color: THEMES.colors.error,
            marginTop: 30,
            display: 'block',
            textAlign: 'center',
            maxWidth: 400,
          }}
        >
          Esse valor é abatido automaticamente na próxima fatura gerada.
          <br />
          Não é possível editar, remover ou devolver manualmente.
        </span>
      </Dialog>

      <Dialog
        widthInPercent={85}
        icon={icons.exclamation}
        open={dialogHistoryInactives}
        title={<span style={{ color: 'red' }}>Histórico de Inativações</span>}
        positiveLabel="Voltar"
        positiveAction={() => setDialogHistoryInactives(false)}
      >
        <St.HistoryInactivesTableContainer>
          {RequestHistoryInactive.data?.data?.length ? (
            <St.HistoryInactivesTable>
              <thead>
                <tr>
                  <th>Nome do Solicitante</th>
                  <th>Status Atual</th>
                  <th>Data da Ocorrência</th>
                  <th>Novo Status</th>
                  <th>Origem</th>
                  <th style={{ borderRight: '1px solid grey' }}>
                    Tipo de Benefício
                  </th>
                </tr>
              </thead>
              <tbody>
                {RequestHistoryInactive.data.data.map((item) => (
                  <tr
                    key={`${item.dataOcorrencia}-${item.nomeSolicitante}-${item.tipoBeneficio}`}
                  >
                    <td>{item.nomeSolicitante}</td>
                    <td>{item.statusAntigo}</td>
                    <td>
                      {moment(item.dataOcorrencia).format('DD/MM/YYYY HH:mm')}
                    </td>
                    <td>{item.statusNovo}</td>
                    <td>{item.origem}</td>
                    <td style={{ borderRight: '1px solid grey' }}>
                      {item.tipoBeneficio}
                    </td>
                  </tr>
                ))}
              </tbody>
            </St.HistoryInactivesTable>
          ) : (
            <ContainerFlex center style={{ height: '100%' }}>
              Não há histórico de inativações
            </ContainerFlex>
          )}
        </St.HistoryInactivesTableContainer>
        {RequestHistoryInactive.data?.totalPages > 1 && (
          <St.HistoryInactivesPaginationContainer>
            <Pagination
              totalPages={RequestHistoryInactive.data.totalPages}
              onCurrentPageChange={fetchHistoryInactive}
              initialCurrentPage={RequestHistoryInactive.data.page}
            />
          </St.HistoryInactivesPaginationContainer>
        )}
      </Dialog>

      <Dialog
        widthInPercent={85}
        icon={icons.exclamation}
        open={dialogHistory}
        title={<span style={{ color: 'red' }}> Histórico de Cartões </span>}
        positiveLabel="Voltar"
        positiveAction={() => setDialogHistory(false)}
      >
        <div style={{ height: 450, overflow: 'scroll' }}>
          <St.TableHistory>
            <thead>
              <tr>
                <th>Número do Cartão</th>
                <th>Status</th>
                <th>Data emissão</th>
                <th>Data ocorrência</th>
                <th style={{ borderRight: '1px solid grey' }}>Descrição</th>
                <th style={{ borderRight: '1px solid grey' }}>Motivo</th>
                {/* <th style={{ borderRight: '1px solid grey' }}>Ação</th> */}
              </tr>
            </thead>
            <tbody>
              {RequestHistoricCard.data?.map((cartao) => (
                <tr>
                  <td>{cartao.cartao}</td>
                  <td>{cartao.status}</td>
                  <td>{moment(cartao.dataEmissao).format('DD/MM/YYYY')}</td>
                  <td>{moment(cartao.dataHistorico).format('DD/MM/YYYY')}</td>
                  <td style={{ borderRight: '1px solid grey' }}>
                    {cartao.operacao}
                  </td>
                  <td style={{ borderRight: '1px solid grey' }}>
                    {cartao.motivo}
                  </td>
                </tr>
              ))}
            </tbody>
          </St.TableHistory>
        </div>
      </Dialog>

      <Dialog
        widthInPercent={85}
        icon={icons.exclamation}
        open={dialogHistory}
        title={<span style={{ color: 'red' }}> Histórico de Cartões </span>}
        positiveLabel="Voltar"
        positiveAction={() => setDialogHistory(false)}
      >
        <div style={{ height: 450, overflow: 'scroll' }}>
          <St.TableHistory>
            <thead>
              <tr>
                <th>Número do Cartão</th>
                <th>Status</th>
                <th>Data emissão</th>
                <th>Data ocorrência</th>
                <th style={{ borderRight: '1px solid grey' }}>Descrição</th>
                <th style={{ borderRight: '1px solid grey' }}>Motivo</th>
                {/* <th style={{ borderRight: '1px solid grey' }}>Ação</th> */}
              </tr>
            </thead>
            <tbody>
              {RequestHistoricCard.data?.map((cartao) => (
                <tr>
                  <td>{cartao.cartao}</td>
                  <td>{cartao.status}</td>
                  <td>{moment(cartao.dataEmissao).format('DD/MM/YYYY')}</td>
                  <td>{moment(cartao.dataHistorico).format('DD/MM/YYYY')}</td>
                  <td style={{ borderRight: '1px solid grey' }}>
                    {cartao.operacao}
                  </td>
                  <td style={{ borderRight: '1px solid grey' }}>
                    {cartao.motivo}
                  </td>
                </tr>
              ))}
            </tbody>
          </St.TableHistory>
        </div>
      </Dialog>

      <Dialog
        widthInPercent={85}
        icon={icons.exclamation}
        open={dialogPlasticHistory}
        title={<span style={{ color: 'red' }}>Histórico do Plástico</span>}
        positiveLabel="Voltar"
        positiveAction={() => setDialogPlasticHistory(false)}
      >
        <div style={{ height: 450, overflow: 'scroll' }}>
          <St.TableHistory>
            <thead>
              <tr>
                <th>Data/Hora</th>
                <th>Nº do cartão</th>
                <th>Evento</th>
                <th>Status do Cartão</th>
                <th>Canal</th>
                <th style={{ borderRight: '1px solid grey' }}>
                  Funcionário
                </th>
              </tr>
            </thead>
            <tbody>
              {RequestPlasticCardHistory.data?.length ? (
                RequestPlasticCardHistory.data.map((item, index) => (
                  <tr key={`${item.dataHistorico}-${item.cartao}-${index}`}>
                    <td>
                      {moment(item.dataHistorico).format(
                        'DD/MM/YYYY HH:mm:ss',
                      )}
                    </td>
                    <td>{item.cartao}</td>
                    <td>{item.operacao}</td>
                    <td>{item.status}</td>
                    <td>{item.canal || '-'}</td>
                    <td style={{ borderRight: '1px solid grey' }}>
                      {item.funcionario || '-'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center' }}>
                    Não há histórico de cartões
                  </td>
                </tr>
              )}
            </tbody>
          </St.TableHistory>
        </div>
      </Dialog>

      <Dialog
        icon={icons.exclamation}
        open={ActivateDialog}
        message={messageActivate}
        positiveLabel="Confirmar"
        negativeLabel="Cancelar"
        negativeAction={() => {
          setActivateDialog(false);
          setSelectedAgreementUsability(null);
        }}
        positiveAction={() => {
          setActivateDialog(false);
          setModalPasswordOpen({ open: true, type: 'limit' });
        }}
      />

      {modalPasswordOpen.type === 'limit' ? (
        <PasswordModal
          onClose={() => {
            setModalPasswordOpen({ open: false, type: '' });
            setSelectedAgreementUsability(null);
          }}
          onSuccessValidation={updateAgreementUsability}
        />
      ) : null}

      <Dialog
        icon={icons.exclamation}
        open={dialogLimitHistory}
        title={
          <span style={{ color: 'red' }}>
            {' '}
            Histórico de Limites de compras{' '}
          </span>
        }
        positiveLabel="Voltar"
        positiveAction={() => setDialogLimitHistory(false)}
      >
        <St.TableHistory>
          <tr>
            <th>Limite anterior</th>
            <th>Novo limite</th>
            <th>Data da alteração</th>
            <th style={{ borderRight: '1px solid grey' }}>Tipo de alteração</th>
          </tr>

          {limitHistoryData.map((item, index) => (
            <tr key={`${item.dataAumentoLimite}-${index}`}>
              <td>{`R$ ${Masks.currencyMask(item.limiteAnterior)}`}</td>
              <td>{`R$ ${Masks.currencyMask(item.valorEstabelecido)}`}</td>
              <td>{moment(item.dataAumentoLimite).format('DD/MM/YYYY')}</td>
              <td style={{ borderRight: '1px solid grey' }}>
                {item.tipoAumento}
              </td>
            </tr>
          ))}
        </St.TableHistory>
        {totalPagesLimitHistory > 1 && (
          <ContainerFlex row horizontal center marginTop={20}>
            <Pagination
              totalPages={totalPagesLimitHistory}
              onCurrentPageChange={(e) => getLimitHistory(e)}
            />
          </ContainerFlex>
        )}
      </Dialog>

      <Dialog
        icon={icons.exclamation}
        open={dialogLimitHistoryWithdraw}
        title={
          <span style={{ color: 'red' }}> Histórico de Limites de saque </span>
        }
        positiveLabel="Voltar"
        positiveAction={() => setDialogLimitHistoryWithdraw(false)}
      >
        <St.TableHistory>
          <tr>
            <th>Limite anterior</th>
            <th>Novo limite</th>
            <th>Data da alteração</th>
            <th style={{ borderRight: '1px solid grey' }}>Tipo de alteração</th>
          </tr>

          {getWithDrawLimitHistory?.data?.map((item) => (
            <tr key={item.dataAcao}>
              <td>{`R$ ${Masks.currencyMask(
                item.limiteSaqueConcedidoAnterior,
              )}`}</td>
              <td>{`R$ ${Masks.currencyMask(
                item.limiteSaqueConcedidoAtual,
              )}`}</td>
              <td>{moment(item.dataAcao).format('DD/MM/YYYY')}</td>
              <td style={{ borderRight: '1px solid grey' }}>
                {item.tipoAumento}
              </td>
            </tr>
          ))}
        </St.TableHistory>
      </Dialog>

      <Dialog
        icon={icons.exclamation}
        open={dialogDuplicateCard}
        negativeLabel="Voltar"
        negativeAction={() => setDialogDuplicateCard(false)}
        buttonDisabledPositive={tax === null || cardDesign === ''}
        positiveLabel="Solicitar"
        positiveAction={() => {
          if (tax !== null && cardDesign !== '') {
            setModalPasswordOpen({ open: true, type: 'twoWayCard' });
          } else if (cardDesign === '') {
            setErrorCardDesign('Selecione uma opção!');
          } else setErrorTax('Selecione uma opção!');
          setErrorTax('');
          setErrorCardDesign('');
        }}
        title={
          <span style={{ color: 'red' }}>Solicitação de 2ª via de Cartão</span>
        }
      >
        {loadingCardInfos ? (
          <ContainerFlex align="center" style={{ padding: 30 }}>
            <Loading status={true} />
          </ContainerFlex>
        ) : (
          <>
            <strong>Design do cartão:</strong>
            <br />
            <Grid xs={1} sm={2} gap={20}>
              {cardInfos.data?.map((el) => (
                <ContainerFlex row center key={el.idExterno}>
                  <RadioButton
                    id={el.idExterno}
                    name="cardDesign"
                    checked={cardDesign === el.modeloTema}
                    onClick={() => setCardDesign(el.modeloTema)}
                  />
                  <St.IconCardDesign src={el.urlImagem} />
                  <strong style={{ color: 'gray' }}>{el.modeloTema}</strong>
                </ContainerFlex>
              ))}
            </Grid>

            <br />
            <St.ErrorMessage>{errorCardDesign}</St.ErrorMessage>
            <br />

            <strong>Cobrar tarifa?</strong>
            <br />
            <ContainerFlex row horizontal align="center" marginBottom={5}>
              <RadioButton
                checked={tax === true}
                onClick={() => setTax(true)}
              />
              Sim
            </ContainerFlex>
            <ContainerFlex row horizontal align="center" marginBottom={5}>
              <RadioButton
                checked={tax === false}
                onClick={() => setTax(false)}
              />
              Não
            </ContainerFlex>
            <St.ErrorMessage>{errorTax}</St.ErrorMessage>
          </>
        )}
      </Dialog>

      <Dialog
        icon={icons.exclamation}
        open={dialogCancelCardShow}
        negativeLabel="Não"
        negativeAction={() => setDialogCancelCardShow(false)}
        positiveLabel="Sim"
        positiveAction={() =>
          setModalPasswordOpen({ open: true, type: 'cancelClient' })
        }
        message="Você tem certeza que deseja cancelar o cliente?"
      >
        {modalPasswordOpen.type === 'cancelClient' ? (
          <PasswordModal
            onClose={() => setModalPasswordOpen({ open: false, type: '' })}
            onSuccessValidation={() => cancel()}
          />
        ) : null}
        <Select
          label="Motivo do cancelamento"
          value={form.tipoCanc}
          options={[
            { id: 'CANCELAMENTO_SOLICITACAO', value: 'Canc. Solic. Cliente' },
          ]}
          onChange={(e) =>
            setForm((prevForm) => ({ ...prevForm, tipoCanc: e }))
          }
        />
      </Dialog>

      {modalPasswordOpen.type === 'twoWayCard' ? (
        <PasswordModal
          onClose={() => setModalPasswordOpen({ open: false, type: '' })}
          onSuccessValidation={() => handleClickDuplicateCard()}
        />
      ) : null}

      <Dialog
        icon={icons.exclamation}
        open={dialogAskBlockCardShow}
        negativeLabel="Cancelar"
        negativeAction={() => setDialogAskBlockCardShow(false)}
        positiveLabel="Bloquear"
        positiveAction={() =>
          setModalPasswordOpen({ open: true, type: 'blockCard' })
        }
        message="Você tem certeza que deseja bloquear o cartão?"
      >
        {modalPasswordOpen.type === 'blockCard' ? (
          <PasswordModal
            onClose={() => setModalPasswordOpen({ open: false, type: '' })}
            onSuccessValidation={() => block()}
          />
        ) : null}
        <Select
          label="Motivo do bloqueio"
          value={reasonForBlocking}
          options={optionsForBlocking}
          onChange={(id) => setReasonForBlocking(id)}
          errorMessage={errorReasonBlock}
        />
      </Dialog>

      <Dialog
        icon={icons.warning}
        open={dialogUpdateLimit}
        message={`Deseja ${
          automaticLimit ? 'DESATIVAR' : 'ATIVAR'
        } o aumento de limite automático para o cliente?`}
        positiveLabel="Sim"
        negativeLabel="Não"
        positiveAction={handleUpdateAutomaticLimit}
        negativeAction={() => setDialogUpdateLimit(false)}
        buttonDisabledPositive={senha?.length !== 6}
      >
        <div style={{ marginTop: 20 }}>
          <Input
            name="senha"
            id="senha"
            type="password"
            label="Digite sua senha para confirmar"
            maxLength={6}
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </div>
      </Dialog>

      <Dialog
        open={openDialog}
        message={popUpMessage}
        positiveAction={() => {
          setOpenDialog(false);
          handleCustomerBase();
        }}
        positiveLabel="Entendi"
        icon={icons.check}
      />

      <Dialog
        open={popUpError}
        message={popUpErrorMessage}
        positiveAction={() => {
          setPopUpError(false);
        }}
        positiveLabel="Entendi"
        icon={icons.warning}
      />

      <Dialog
        icon={icons.exclamation}
        open={dialogErrorCancelCard}
        positiveLabel="Entendi"
        positiveAction={() => setDialogErrorCancelCard(false)}
        message={dialogText}
      />

      <Dialog
        icon={icons.confirmation}
        open={dialogCancelCardIsOpen}
        positiveLabel="Entendi"
        positiveAction={() => goBack()}
        message={dialogText}
      />
    </ContainerFlex>
  );
};

export default ProductContainer;
